import React from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import { XIcon } from "lucide-react";
import { ReactComponent as GoogleDriveIcon } from "../../../static/icons/google-drive.svg";
import { localStorageKeys } from "../../../lib/local-storage-keys";
import { useGoogleDriveStatus } from "../../../data/queries/use-google-drive-settings";
import { useGoogleDriveConnectFlow } from "../../../data/hooks/use-google-drive-connect-flow";
import { GoogleDriveConnectDialog } from "./google-drive-connect-dialog";

export function useGoogleDriveBannerVisible() {
    const { data: status, isLoading } = useGoogleDriveStatus();
    const [dismissed] = useLocalStorage<boolean>(localStorageKeys.googleDriveTopBannerDismissed, false);

    if (isLoading || dismissed || status?.connected) return false;
    return true;
}

export function GoogleDriveTopBanner() {
    const { data: status, isLoading } = useGoogleDriveStatus();
    const [dismissed, setDismissed] = useLocalStorage<boolean>(localStorageKeys.googleDriveTopBannerDismissed, false);
    const connectFlow = useGoogleDriveConnectFlow();

    if (isLoading || dismissed || status?.connected) return null;

    return (
        <>
            <div className="fixed left-0 right-0 top-0 z-[60] flex h-12 items-center justify-center gap-3 bg-primary px-4 text-sm text-primary-foreground">
                <GoogleDriveIcon className="h-4 w-4 shrink-0" />
                <span>
                    <strong>Connect Google Drive</strong> and Tekkr will automatically surface your relevant files when
                    you need them.
                </span>
                <button
                    onClick={connectFlow.openDialog}
                    className="ml-2 shrink-0 rounded-md bg-primary-foreground/20 px-3 py-1 text-sm font-medium transition-colors hover:bg-primary-foreground/30"
                >
                    Connect now &rarr;
                </button>
                <button
                    onClick={() => setDismissed(true)}
                    className="absolute right-4 rounded-md p-1 transition-colors hover:bg-primary-foreground/20"
                    aria-label="Dismiss banner"
                >
                    <XIcon className="h-4 w-4" />
                </button>
            </div>
            <GoogleDriveConnectDialog
                open={connectFlow.dialogOpen}
                onOpenChange={connectFlow.setDialogOpen}
                storageLevel={connectFlow.storageLevel}
                onStorageLevelChange={connectFlow.setStorageLevel}
                accessMode={connectFlow.accessMode}
                onAccessModeChange={connectFlow.setAccessMode}
                onConnect={connectFlow.connect}
                connecting={connectFlow.connecting}
                isPending={connectFlow.isPending}
                success={connectFlow.success}
                canConnect={connectFlow.canConnect}
            />
        </>
    );
}
